import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import Loading from '../general/Loading';

const ManageProfile = ({userData}) => {
  const [myIndex, setMyIndex] = useState([]);
  const [selectedInd, setSelectedInd] = useState('');
  const [isEditMode, setIsEditMode] = useState(false);
    const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
    const [myData, setMyData] = useState({
        premium_amt: userData.upi_id || '',
        referral_value: userData.ref_by || 10,
        com_value: userData.exp_level || 10,
    })

    const [formData, setFormData] = useState({
      index_name: '',
      country: '',
      currency: '',
      symbol: ''
    })


      const handleChange = (e) => {
    const { name, value } = e.target;
    setMyData({
      ...myData,
      [name]: value,
    });
  };


        const handleIndexChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };



    useEffect(() => {
      fetchIndexes();
    }, []);
  
    const fetchIndexes = async () => {
      setLoading(true);
      try {
        const response = await fetch('https://api.tradeintell.com/get-indexes');
        if (response.ok) {
          const data = await response.json();
          setMyIndex(data);
        } else {
          console.error('Failed to fetch topics');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };


const handleUpdate = async (e) => {
      e.preventDefault();

      try {
        setLoading(true);
  
  
        const response = await fetch(`https://api.tradeintell.com/set-admin-value/${userData.id}` , {
          method:  'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(myData)
        });
  
        const data = await response.json();
  
        if (!response.ok) {
          throw new Error(data.message || 'Something went wrong');
        }
  
      
                localStorage.removeItem('userData');
                  localStorage.setItem('userData', JSON.stringify(data));

        toast.success('Admin settings updated.');
  
      } catch (error) {
        toast.error(error.message || 'Something went wrong. Try again.');
      } finally {
        setLoading(false);
      }
}


    const handleSubmit = async (e) => {
      e.preventDefault();
  
      // if (!formData.edu_link || !formData.topic) {
      //   toast.error('Please fill all required fields.');
      //   return;
      // }
  
      try {
        setLoading(true);
  
        const apiUrl = isEditMode 
          ? `https://api.tradeintell.com/edit-myIndex/${selectedInd.id}` 
          : 'https://api.tradeintell.com/create-myIndex';
  
        const response = await fetch(apiUrl, {
          method: isEditMode ? 'PUT' : 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });
  
        const data = await response.json();
  
        if (!response.ok) {
          throw new Error(data.message || 'Something went wrong');
        }
  
        toast.success(isEditMode ? 'Index List Updated.' : 'New Index Added to List.');
        setShowForm(false);
        setIsEditMode(false);
        setSelectedInd(null);
        setFormData({
      index_name: '',
      country: '',
      currency: '',
      symbol: ''
        });
  
        fetchIndexes();
      } catch (error) {
        toast.error(error.message || 'Something went wrong. Try again.');
      } finally {
        setLoading(false);
      }
    };


    const formatDate = (timestamp) => {
  const date = new Date(timestamp);
  const options = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  };
  return date.toLocaleString('en-US', options);
};


    const handleManage = (ind) => {
      setShowForm(true);
      setIsEditMode(true);
      setSelectedInd(ind);
      setFormData({
              index_name: ind.index_name,
      country: ind.country,
      currency: ind.currency,
      symbol: ind.symbol
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    
    const handleRemove = (ind) => {
      setShowDelete(true);
      setSelectedInd(ind);
    }

    const handleDelete = async (tId) => {
  try {
    const response = await fetch(`https://api.tradeintell.com/remove-index/${tId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const data = await response.json();
    console.log('Removed successfully:', data);
        toast.success('Index Deleted Successfully.');
        setShowDelete(false);
        setSelectedInd('');
        fetchIndexes();


  } catch (error) {
    console.error('Failed to remove item:', error);
  }
};



  return (
    <>
          <section className='my-4'>
        <div className='px-4'>
          <p className='page-heading'>Profile Settings</p>
          <p className='para-text text-muted'>Update Credentials, Set Premium Plan Pricing, Referral Value & more.</p>

<div className='row'>


<div className='col-lg-4 col-md-6 col-12 my-2'>
                  <form className='mt-3' onSubmit={handleUpdate}>

                    <p className='page-heading fs-6 mb-2'>Premium Plan Pricing ₹</p>
                    <input
                      type="text"
                      name="premium_amt"
                    //   placeholder="Premium Plan Pricing*"
                      value={myData.premium_amt}
                      onChange={handleChange}
                      className="contact-control bg-white"
required
                    />

                                        <p className='page-heading fs-6 mt-3 mb-2'>Set Referral Value %</p>
                    <input
                      type="text"
                      name="referral_value"
                    //   placeholder="Referral Value*"
                      value={myData.referral_value}
                      onChange={handleChange}
                      className="contact-control bg-white"
                    />

                                        <p className='page-heading fs-6 mt-3 mb-2'>Commission Value %</p>

                                        <input
                      type="text"
                      name="com_value"
                    //   placeholder="Premium Plan Pricing*"
                      value={myData.com_value}
                      onChange={handleChange}
                      className="contact-control bg-white"
required
                    />


                    <button
                      type="submit"
                      className="header-btn py-2 w-100 mt-3"
                      disabled={loading}
                    >
                     Save
                    </button>
</form>
</div>
{/* left ends */}


<div className='col-lg-8 col-md-6 col-12 my-2 table-responsive'>
<div className='bg-white p-3'>

  <div className='d-flex justify-content-between'>
                                        <p className='page-heading fs-6'>Index List</p>
                {!isEditMode && (
            <button className='about-btn mb-3' onClick={() => setShowForm(!showForm)}>
              {showForm ? 'CANCEL' : 'NEW +'}
            </button>
          )}
</div>



<table className='w-100 table'>
  <tr className='border-bottom'>
    <th className='p-2'>SNo</th>
    <th className='p-2'>Index</th>
    <th className='p-2'>Market</th>
    <th className='p-2'>Currency</th>
    <th className='p-2'>Symbol</th>
    <th className='p-2'>Added On</th>
    <th className='p-2'>Activity</th>
  </tr>


{showForm && (
  <tr>
    <td className="p-2">-</td>

    <td className="p-2">
      <input
        type="text"
        name="index_name"
        value={formData.index_name}
        onChange={handleIndexChange}
        className="contact-control border-0"
        placeholder="Index Name"
        required
      />
    </td>

    <td className="p-2">
      <input
        type="text"
        name="country"
        value={formData.country}
        onChange={handleIndexChange}
        className="contact-control border-0"
        placeholder="Indian"
        required
      />
    </td>

    <td className="p-2">
      <input
        type="text"
        name="currency"
        value={formData.currency}
        onChange={handleIndexChange}
        className="contact-control border-0"
        placeholder="INR, USD.."
required
      />
    </td>

    <td className="p-2">
      <input
        type="text"
        name="symbol"
        value={formData.symbol}
        onChange={handleIndexChange}
        className="contact-control border-0"
        placeholder="$, ₹, ฿, €.."
        required
      />
    </td>

    <td className="p-2">-</td>

    <td className="p-2">
      <button
        className="header-btn bg-black text-light py-1 px-3"
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? "Saving..." : "Save"}
      </button>
    </td>
  </tr>
)}


            {myIndex.length > 0 ? (
              myIndex.map((ind, index) => (
                <tr className="col-lg-4 col-md-6 col-12 my-2" key={ind.id}>
                  <td className='p-2'>{index + 1}</td>
                  <td className='p-2'>{ind.index_name}</td>
                  <td className='p-2'>{ind.country}</td>
                  <td className='p-2'>{ind.currency}</td>
                  <td className='p-2'>{ind.symbol}</td>
                  <td className='p-2'>{formatDate(ind.added_on)}</td>

      <td className="p-2">

            {!isEditMode && (
              <>
                    <button         className="header-btn bg-black text-light py-1 px-2 me-2"
 onClick={() => handleManage(ind)}>
                      Manage
                    </button>             
                                        <button         className="header-btn bg-danger text-light py-1 px-2"
 onClick={() => handleRemove(ind)}>
                      Remove
                    </button>               </>)}

              {isEditMode && selectedInd.id == ind.id &&
                                  <button         className="header-btn bg-black text-light py-1 px-3"
 onClick={() => {setIsEditMode(false); setShowForm(false); setSelectedInd('')}}>
                      Close
                    </button>               
}      
</td>

                </tr>
              ))
            ) : (
              <p>No Plans Created yet.</p>
            )}


  </table>
</div></div>
{/* right ends */}

</div>
{/* row ends */}

</div>
</section>
    
          {loading && <Loading setLoading={setLoading} />}

{showDelete && (
  <>
    <section className='detail-dialog p-2' onClick={() => setShowDelete(false)}>
                    <div className='detail-dialog-inner col-lg-5 animate__animated animate__zoomIn rounded mx-auto px-lg-5 py-lg-5 px-3 py-3 text-center' onClick={(e) => e.stopPropagation()}>

                        <p className='sidebar-menu-title text-dark fs-6'>Remove {selectedInd.index_name} Index!</p>

                        <button className='btn-style1' onClick={() => handleDelete(selectedInd.id)}>Yes</button>&nbsp;&nbsp;
                        <button className='btn-style2' onClick={() => setShowDelete(false)}>No</button>

                    </div>
                </section>

  </>
)}

    </>
  )
}

export default ManageProfile